/* eslint-disable consistent-return */
import { nanoid } from "nanoid";

import { handleError } from "@/redux/utils/error";
import * as pdfApi from "@/apiv2/generatePdf";
import * as alertActions from "@/redux/alerts/alerts.actions";

import * as pdfDataTemplate from "./pdfDataTemplate";
import { SET_IS_GENERATING_PREVIEW_PDF_STATUS } from "./generatePdf.actionTypes";

export const setIsGeneratingPreviewPdfStatus = (data) => (dispatch) => {
  dispatch({
    type: SET_IS_GENERATING_PREVIEW_PDF_STATUS,
    payload: data,
  });
};

export const generatePdf =
  ({
    options = {
      swapPageNumberToTheLeftSide: false,
    },
    templateType,
    fileName,
    attachments,
    payload,
  }) =>
  async (dispatch) => {
    try {
      const { data: defaultTemplate } = await pdfApi.getDefaultTemplateByType(templateType)();

      if (defaultTemplate) {
        const { data } = await pdfApi.postGeneratePdf({
          fileName,
          templateType: defaultTemplate.templateKey.toUpperCase(),
          templateHtmlUrl: defaultTemplate.htmlFile,
          templateData: pdfDataTemplate.getDataTemplate({ ...payload, templateType }),
          imageAttachments: attachments.images,
          pdfAttachments: attachments.pdfs,
          options,
        })();

        return data;
      }

      await dispatch(
        alertActions.createAlertAction(
          nanoid(),
          `No "${templateType} template was found.`,
          false,
          "danger"
        )
      );
    } catch (error) {
      console.log(error);
      handleError(error, dispatch);
    }
  };

// Invoice and Quote
export const generatePdfData =
  ({ orderUid, templateType, payload }) =>
  async (dispatch) => {
    try {
      const { imageAttachmentUids, pdfAttachmentUids, isPreview, isEmail, ...rest } = payload;
      const formData = {
        order_id: orderUid,
        attachment_images: imageAttachmentUids,
        attachment_pdfs: pdfAttachmentUids,
        is_preview: isPreview,
        is_email: isEmail,
        ...rest,
      };

      const apiMap = {
        INVOICE: pdfApi.postGenerateInvoice,
        QUOTE: pdfApi.postGenerateQuote,
      };

      const { data } = await apiMap[templateType](formData)();
      return data;
    } catch (error) {
      handleError(error, dispatch);
    }
  };

// Work Order Pdf
export const generateWorkOrder =
  ({ orderUid, payload = {} } = {}) =>
  async (dispatch) => {
    try {
      const { imageAttachmentUids, pdfAttachmentUids, isPreview, ...rest } = payload;
      const formData = {
        order_id: orderUid,
        product_ids: payload?.productIds ?? undefined,
        drawing_ids: payload?.drawingIds ?? undefined,
      };

      const { data } = await pdfApi.postGenerateWorkOrder(formData)();

      return data;
    } catch (error) {
      console.log(error);
      handleError(error, dispatch);
    }
  };

export const generatePartialInvoice =
  ({ orderUid, payload }) =>
  async (dispatch) => {
    try {
      const formData = {
        order_id: orderUid,
        attachment_images: payload.imageAttachmentUids,
        attachment_pdfs: payload.pdfAttachmentUids,
        invoiced_date: payload.invoicedDate,
        is_preview: payload.isPreview,
        is_email: payload.isEmail,
        invoice_type: payload.invoiceType,
        value: payload.value,
        items: payload.items,
        delivery_fee:
          payload.deliveryFee && parseFloat(payload.deliveryFee) > 0
            ? payload.deliveryFee
            : undefined,
      };

      const { data } = await pdfApi.postGeneratePartialInvoice(formData)();
      return data;
    } catch (error) {
      handleError(error, dispatch);
    }
  };

export const emailPdf =
  ({ customerUid, orderUid, type, payload }) =>
  async (dispatch) => {
    try {
      const formData = {
        type,
        attachments: payload.attachmentUids,
        emails: payload.contactsToEmail,
        pdf_date: payload.pdfDate,
        custom_email_message: payload.customEmailMessage,
        pdf_url: payload.pdfUrl,
        partial_invoice: payload.partialInvoiceId || undefined,
      };

      const { data } = await pdfApi.postEmailPdf({ customerUid, orderUid, data: formData })();
      return data;
    } catch (error) {
      handleError(error, dispatch);
    }
  };

export default {};
